import IconButton from '@/components/IconButton/IconButton';
import { type WidgetId } from '@/features/dashboard/registry';
import { formatRelativeTime } from '@/lib/formatRelativeTime';

import WidgetSettingsButton from './WidgetSettingsButton';

const RefreshIcon = (
  <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className="h-4 w-4">
    <path
      fillRule="evenodd"
      d="M15.312 11.424a5.5 5.5 0 01-9.201 2.466l-.312-.311h2.433a.75.75 0 000-1.5H3.989a.75.75 0 00-.75.75v4.242a.75.75 0 001.5 0v-2.43l.31.31a7 7 0 0011.712-3.138.75.75 0 00-1.449-.39zm1.23-3.723a.75.75 0 00.219-.53V2.929a.75.75 0 00-1.5 0v2.42l-.31-.31A7 7 0 003.239 8.176a.75.75 0 101.45.39A5.5 5.5 0 0113.89 6.1l.311.31h-2.432a.75.75 0 000 1.5h4.243a.75.75 0 00.53-.219z"
      clipRule="evenodd"
    />
  </svg>
);

interface WidgetDetailChromeProps {
  /** When set (and the widget has a settings form), renders a settings gear. */
  widgetId?: WidgetId;
  lastUpdated?: Date | null;
  onRefresh?: () => void;
}

/**
 * Compact toolbar for a widget's detail modal: "updated N ago", a refresh
 * button, and the settings gear. This is where refresh + settings live now
 * that widget tile faces are chrome-free.
 */
export default function WidgetDetailChrome({ widgetId, lastUpdated, onRefresh }: WidgetDetailChromeProps) {
  if (!widgetId && !lastUpdated && !onRefresh) return null;

  return (
    <div className="mb-4 flex items-center justify-end gap-2 text-xs text-(--text-muted)">
      {lastUpdated && <span className="tabular-nums">Updated {formatRelativeTime(lastUpdated)}</span>}
      {onRefresh && <IconButton variant="ghost" size="sm" aria-label="Refresh" onClick={onRefresh} icon={RefreshIcon} />}
      {widgetId && <WidgetSettingsButton widgetId={widgetId} />}
    </div>
  );
}
